<template>
    <Card :title="$t('labels.sms_template')">
        <div class="card-body">
            <div class="row">
                <div class="col-lg-6">
                    <FormGroup :label="$t('labels.name')" required>
                        <Input v-model="name" />
                    </FormGroup>
                </div>
                <div class="col-lg-6">
                    <FormGroup :label="$t('labels.api_credentials')" required>
                        <AppAutoComplete
                            :url="`/projects/${$route.params.projectUuid}/core/api-credentials`"
                            :model-value="apiCredential?.uuid"
                            :selected-value="apiCredential?.name"
                            @update:model-value="apiCredential = $event"
                            :query-params="{
                                service: 'intel-tele'
                            }"
                        >
                            <template #optionContent>
                                <template v-if="!apiCredential">
                                    <span class="text-muted">{{ $t('labels.empty') }}</span>
                                </template>
                                <template v-else>
                                    {{ apiCredential.name }}
                                    <span :class="['badge', apiCredential.is_active ? 'badge-success' : 'badge-danger', 'ml-2']">
                                        {{ apiCredential.is_active ? $t('labels.active') : $t('labels.inactive') }}
                                    </span>
                                </template>
                            </template>
                            <template #optionItem="{ option, index }">
                                {{ option.name }}
                                <span :class="['badge', option.is_active ? 'badge-success' : 'badge-danger', 'ml-2']">
                                    {{ option.is_active ? $t('labels.active') : $t('labels.inactive') }}
                                </span>
                            </template>
                        </AppAutoComplete>
                    </FormGroup>
                </div>
                <div class="col-lg-8">
                    <FormGroup :label="$t('labels.text')" required>
                        <Formula v-model:formula="text" :items="formulaItems"/>
                    </FormGroup>
                </div>
                <div class="col-lg-2">
                    <FormGroup :label="$t('labels.sender_name')" required>
                        <Input v-model="sender_name" />
                    </FormGroup>
                </div>
                <div class="col-lg-2">
                    <FormGroup :label="$t('labels.send_once')" required>
                        <AppCheckbox v-model="sendOnce" />
                    </FormGroup>
                </div>
            </div>
        </div>
        <div class="card-footer d-flex justify-content-end">
            <AppButton color="indigo" @click="createSmsTemplate" :disabled="!name || !apiCredential || !text || !sender_name">
                <i class="icon-floppy-disk mr-2"></i>
                {{ $t('buttons.create') }}
            </AppButton>
        </div>
    </Card>
</template>
<script>
import Card from "../../../../components/new/CardComponent.vue";
import FormGroup from "../../../../components/new/form/group/FormGroup.vue";
import Input from "../../../../components/new/form/Input.vue";
import AppAutoComplete from "../../../../components/new/form/autocomplete/AppAutoComplete.vue";
import Formula from "../../../../components/form/FormulaComponent.vue";
import AppButton from "../../../../components/new/button/AppButton.vue";

import { httpClient } from "../../../../services/HttpClient";
import AppCheckbox from "../../../../components/new/form/checkbox/AppCheckbox.vue";

export default {
    name: 'SmsTemplatesCreatePage',
    components: {
        AppCheckbox,
        Card, FormGroup, Input, AppAutoComplete, Formula, AppButton
    },
    data() {
        return {
            name: '',
            sender_name: '',
            sendOnce: false,
            apiCredential: null,
            text: '',
            orderCustomFields: []
        };
    },
    methods: {
        fetchOrderCustomFields() {
            httpClient.get(`/projects/${this.$route.params.projectUuid}/crm/custom-fields`, {
                limit: 100
            }).then((response) => {
                this.orderCustomFields = response.data.data
            })
        },
        createSmsTemplate() {
            httpClient.post(`/projects/${this.$route.params.projectUuid}/crm/sms-templates`, {
                name: this.name,
                api_credentials_uuid: this.apiCredential?.uuid,
                sender_name: this.sender_name,
                text: this.text,
                send_once: this.sendOnce
            }).then((response) => {
                this.$router.replace({
                    name: 'SmsTemplatesEditPage',
                    params: { smsTemplateUuid: response.data.data.uuid }
                })
            })
        }
    },
    computed: {
        formulaItems() {
            let items = [
                {code: '{$deliveryCompanyNumber}', name: this.$t('labels.ttn')},
                {code: '{$orderSum}', name: this.$t('labels.order_sum')},
                {code: '{$orderExternalId}', name: this.$t('labels.order_external_id')},
            ];

            this.orderCustomFields.forEach((field) => {
                items.push({
                    name: field.name,
                    code: `{$customField[${field.uuid}]}`
                });
            });

            return items;
        }
    },
    mounted() {
        this.fetchOrderCustomFields();
    }
}
</script>
